import * as moment from "moment";

export function parseReporterQueryValue(reporters: string | null): string[] {
  if (!reporters) {
    return [];
  }

  try {
    const parsedValue = JSON.parse(reporters);
    if (Array.isArray(parsedValue)) {
      return parsedValue
        .map((value) => String(value || "").trim())
        .filter((value) => value);
    }
  } catch {
    return reporters
      .split(",")
      .map((value) => value.trim())
      .filter((value) => value);
  }

  return [];
}

export function normalizeProjectKeys(jiraProjectKey: string): string[] {
  if (!jiraProjectKey) {
    return [];
  }

  const trimmedProjectKey = jiraProjectKey.trim();

  if (trimmedProjectKey.startsWith("[")) {
    try {
      const parsedValue = JSON.parse(trimmedProjectKey);
      if (Array.isArray(parsedValue)) {
        return parsedValue
          .map((value) => String(value).trim())
          .filter((value) => value);
      }
    } catch {
      return [trimmedProjectKey];
    }
  }

  if (trimmedProjectKey.includes(",")) {
    return trimmedProjectKey
      .split(",")
      .map((value) => value.trim())
      .filter((value) => value);
  }

  return [trimmedProjectKey];
}

export function isValidDate(date: string | null): date is string {
  return Boolean(date) && moment(date, "YYYY-MM-DD", true).isValid();
}

export function normalizeResponse<T>(result: any): T | null {
  if (result == null) {
    return null;
  }

  let response = result?.body !== undefined ? result.body : result;
  if (typeof response === "string") {
    try {
      response = JSON.parse(response);
    } catch {
      return null;
    }
  }

  return response as T;
}

export function isSuccessResponse(
  response: { status?: string | number; s?: string | number } | null
): boolean {
  return Boolean(response) && (response?.status == "1" || response?.s == "1");
}

export function getErrorMessage(
  error: unknown,
  fallbackMessage: string
): string {
  if (typeof error === "string" && error.trim()) {
    return error;
  }

  if (
    error &&
    typeof error === "object" &&
    "message" in error &&
    typeof (error as { message: string }).message === "string"
  ) {
    return (error as { message: string }).message;
  }

  return fallbackMessage;
}
